// Single source of truth for the API/backend origin.
//
// Strategy:
// 1. In the browser, always use the page's own origin. This guarantees that
//    the frontend (served at https://ficopilot.app) calls
//    https://ficopilot.app/api/* — i.e. same-origin, no CORS preflight,
//    cookies (session_token / access_token) flow without SameSite issues.
//    Kubernetes ingress routes /api/* to the FastAPI backend automatically.
// 2. Fall back to REACT_APP_BACKEND_URL for non-browser contexts (SSR/tests).
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

export const BACKEND_ORIGIN =
  typeof window !== "undefined" && window.location?.origin
    ? window.location.origin
    : ENV_URL;

export const API_BASE = `${BACKEND_ORIGIN}/api`;
